(function () {

  require('./homepage/jquery.carousel.js');

  //var widget = $('.check-reservation');
  var FormTabsEngine = require('./global/form-tabs-engine');
  var formOptions = require('./global/widget-defaults')();
  var PreparePostInit = require('./global/preparePostInitHookFunction');

  formOptions = PreparePostInit(formOptions, []);

  var atForms = new FormTabsEngine({
    'form-1': ['airticketForm', formOptions.letenky]
  });

  atForms.init('form-1');

  // homepage banner slider
  $('.infinite-carousel').infiniteCarousel();

  //$('h4', widget).click(toggleWidget);

  $('.letenky .content').airticketOffersWidget({
    pageName: 'letenky-homepage',
    component_id: 'studentagency.sk',
    text: 'Mapa akciových leteniek',
    targetUrl: '/letenky/mapa-akcnych-leteniek/',
    set: 'default_sk'
  });

  /*$('#action-offers-table').airticketOffersTable({
    id: 'studentagency.cz',
    limit: 6,
    slider: true,
    tripTypeIcons: true
  });*/

  /*function toggleWidget () {
    if ($('form', widget).is(':visible'))
      $('form', widget).slideUp();
    else
      $('form', widget).slideDown();
  }*/

  if(window.getUrlParameter('newsletter')) {
    openNewsletter();
  }

  function openNewsletter() {
    var opts = {
      "empty": true,
      "type": "email",
          "message": {
            "icon": "sa-icon icon-email"
      }
      };
    var lb = $().lightbox;
    lb.create(null, 'icon-lightbox', window.customRenderFunction, opts);
    var lbWrapper = $('.lb-main-content.lb-email');
    lbWrapper.generalForm({
      "dataPath": "/sys/bloky/form/letenky-newsletter.json",
      "scrollToForm": false,
      "noScroll": true,
      "noFormClass": true,
      "reloadWithoutParams": true
    })
  }
})();



// WEBPACK FOOTER //
// ./src/js/letenky.js